// extracted by mini-css-extract-plugin
export var dividerContainer = "_9b-0";
export var line = "_9b-1";